// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceStatusContent,
  unionToDeviceStatusContent,
  unionListToDeviceStatusContent,
} from "./device-status-content";
import {
  ElevatorStatusMessage,
  ElevatorStatusMessageT,
  verifyElevatorStatusMessage,
} from "./elevator-status-message";
import {
  EscalatorStatusMessage,
  EscalatorStatusMessageT,
  verifyEscalatorStatusMessage,
} from "./escalator-status-message";

export class StatusMessage implements flatbuffers.IUnpackableObject<StatusMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StatusMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStatusMessage(bb: flatbuffers.ByteBuffer, obj?: StatusMessage): StatusMessage {
    return (obj || new StatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStatusMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: StatusMessage,
  ): StatusMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  statusType(): DeviceStatusContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceStatusContent.NONE;
  }

  status<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startStatusMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addStatusType(builder: flatbuffers.Builder, statusType: DeviceStatusContent) {
    builder.addFieldInt8(0, statusType, DeviceStatusContent.NONE);
  }

  static addStatus(builder: flatbuffers.Builder, statusOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, statusOffset, 0);
  }

  static endStatusMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // status
    return offset;
  }

  static createStatusMessage(
    builder: flatbuffers.Builder,
    statusType: DeviceStatusContent,
    statusOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    StatusMessage.startStatusMessage(builder);
    StatusMessage.addStatusType(builder, statusType);
    StatusMessage.addStatus(builder, statusOffset);
    return StatusMessage.endStatusMessage(builder);
  }

  unpack(): StatusMessageT {
    return new StatusMessageT(
      this.statusType(),
      (() => {
        const temp = unionToDeviceStatusContent(this.statusType(), this.status.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: StatusMessageT): void {
    _o.statusType = this.statusType();
    _o.status = (() => {
      const temp = unionToDeviceStatusContent(this.statusType(), this.status.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): StatusMessageT {
    const t = new StatusMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("status_type")) {
      t.statusType = this.statusType();
    }
    if (fieldSet.has("status")) {
      t.status = (() => {
        const temp = unionToDeviceStatusContent(this.statusType(), this.status.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class StatusMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public statusType: DeviceStatusContent = DeviceStatusContent.NONE,
    public status: ElevatorStatusMessageT | EscalatorStatusMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.status === null || this.status === undefined) {
      throw new Error('Required field "status" is not set');
    }
    const status = builder.createObjectOffset(this.status);

    return StatusMessage.createStatusMessage(builder, this.statusType, status);
  }

  clone(): StatusMessageT {
    const obj = new StatusMessageT();
    obj.statusType = this.statusType;
    obj.status =
      this.status !== null && typeof (this.status as any).clone === "function"
        ? (this.status as any).clone()
        : this.status;
    return obj;
  }

  equals(other: StatusMessageT): boolean {
    if (this.statusType !== other.statusType) return false;
    if (this.status !== null && other.status !== null) {
      if (typeof (this.status as any).equals === "function") {
        if (!(this.status as any).equals(other.status)) return false;
      } else if (this.status !== other.status) return false;
    } else if (this.status !== other.status) return false;
    return true;
  }
}

export function verifyStatusMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "status");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorStatusMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorStatusMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "status");
  } finally {
    verifier.popDepth();
  }
}
